import ChevronUp from './src/chevron-up-combined';
export default ChevronUp;